<template>
  <div :class="computedClass">
    <div class="mb-4">
      <span class="font-bold">Processamento Manual</span>
      <div class="flex flex-row gap-1">
        <v-select
          v-model="action"
          :options="actions"
          label="label"
          value="value"
          placeholder="Selecionar Ação"
          :reduce="(item) => item.value"
          style="width: 250px"
        ></v-select>
        <div class="flex flex-row gap-4">
          <flat-pickr
            v-show="action === MAXPAR_MANUAL_ACTIONS.CANCEL.value"
            class="input-data-cancelamento w-full sm:mb-0 mb-3"
            name="Data de cancelamento"
            id="Data de cancelamento"
            data-testid="cancelation-date"
            v-model="cancellationDate"
            style="width: 150px"
            :config="getConfigDatePicker()"
            placeholder="Data de cancelamento"
          />
        </div>
        <div class="flex flex-row gap-4">
          <flat-pickr
            v-show="action === MAXPAR_MANUAL_ACTIONS.CHANGE.value"
            class="input-data-cancelamento w-full sm:mb-0 mb-3"
            name="Data de Alteração"
            id="Data de Alteração"
            data-testid="change-endosment-date"
            v-model="changeEndorsementDate"
            style="width: 150px"
            :config="getConfigDatePicker()"
            placeholder="Data de Alteração"
          />
        </div>
        <div class="flex flex-row gap-4">
          <vs-input
            v-show="
              action === MAXPAR_MANUAL_ACTIONS.CANCEL.value ||
              action === MAXPAR_MANUAL_ACTIONS.CHANGE.value
            "
            type="number"
            class="w-full sm:mb-0 mb-3"
            name="Nº do endosso"
            id="Nº do endosso"
            v-model="endorsementNumber"
            data-testid="cancelation-date"
            placeholder="Nº do endosso"
            style="width: 150px"
          />
        </div>
        <div class="flex flex-row gap-4">
          <vs-input
            v-show="action === MAXPAR_MANUAL_ACTIONS.CHANGE.value"
            type="number"
            class="w-full sm:mb-0 mb-3"
            name="Nº Apólice Original"
            id="Nº Apólice Original"
            v-model="numberOriginalPolicy"
            data-testid="number-policy-original"
            placeholder="Nº Apólice Original"
            style="width: 150px"
          />
        </div>
        <vs-button
          color="primary"
          type="border"
          :disabled="
            !action ||
            (action === MAXPAR_MANUAL_ACTIONS.CANCEL.value &&
              !(cancellationDate && endorsementNumber)) ||
            (action === MAXPAR_MANUAL_ACTIONS.CHANGE.value &&
              !(
                endorsementNumber &&
                changeEndorsementDate &&
                numberOriginalPolicy
              ))
          "
          @click="execute"
          class="font-bold"
          >Executar</vs-button
        >
        <vs-button
          icon="refresh"
          @click="reloadData"
          color="primary"
          type="border"
        />
      </div>
    </div>
    <vs-collapse type="border">
      <vs-collapse-item v-for="(item, index) in logs" :key="index">
        <div class="flex flex-row" slot="header">
          <span class="font-bold mr-4">{{ item.action }}</span>
          <vs-chip class="mr-3" :color="defineCorChipMaxpar(item.status)">{{
            item.status
          }}</vs-chip>
        </div>
        <div v-if="item.tries">
          <span class="font-bold">Tentativas: </span>
          <span>{{ item.tries }}</span>
        </div>
        <div v-if="item.syncDate">
          <span class="font-bold">Data de sincronização: </span>
          <span>{{ functions.formataDataHoraPadraoBR(item.syncDate) }}</span>
        </div>
        <div v-if="item.action === MAXPAR_MANUAL_ACTIONS.CANCEL.value">
          <span class="font-bold">Data do cancelamento: </span>
          <span>{{
            functions.formataDataMomentJS(
              item.cancellationDate,
              'DD/MM/YYYY',
              3,
            )
          }}</span>
        </div>
        <div v-if="item.action === MAXPAR_MANUAL_ACTIONS.CANCEL.value">
          <span class="font-bold">Nº do endosso: </span>
          <span>{{ item.endorsementNumber }}</span>
        </div>
        <div>
          <span class="font-bold">Usuário: </span>
          <span>{{ formatResponsavel(item) }}</span>
        </div>

        <vs-tabs class="mt-3" alignment="fixed">
          <vs-tab label="Payload">
            <div class="tab-text">
              <vue-json-pretty
                :path="'res'"
                :data="retornaJson(item.payload)"
              ></vue-json-pretty>
            </div>
          </vs-tab>
          <vs-tab label="Resposta">
            <div class="tab-text">
              <vue-json-pretty
                :path="'res'"
                :data="retornaJson(item.response)"
              ></vue-json-pretty>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import vSelect from 'vue-select';
import 'vue-json-pretty/lib/styles.css';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import maxparApiService from '../../../../services/maxpar.api';
import moment from 'moment';
import { MAXPAR_MANUAL_ACTIONS } from '@/utils/constants';
import flatPickr from 'vue-flatpickr-component';
import { formatResponsavel } from '../../../../utils/integrationHelpers';

export default {
  name: 'MaxparIntegrationContent',
  props: ['logs', 'policy-id'],
  components: {
    VueJsonPretty,
    vSelect,
    flatPickr,
  },
  computed: {
    MAXPAR_MANUAL_ACTIONS() {
      return MAXPAR_MANUAL_ACTIONS;
    },
    computedClass() {
      const hasLogs = Array.isArray(this.logs) && this.logs.length === 0;
      return hasLogs ? 'pb-24' : 'pb-4';
    },
  },
  data() {
    return {
      functions,
      actions: [
        MAXPAR_MANUAL_ACTIONS.CREATE,
        MAXPAR_MANUAL_ACTIONS.CANCEL,
        MAXPAR_MANUAL_ACTIONS.CHANGE,
      ],
      action: null,
      cancellationDate: null,
      changeEndorsementDate: null,
      endorsementNumber: null,
      numberOriginalPolicy: null,
      showActionsLocal: true,
    };
  },
  methods: {
    formatResponsavel,
    defineCorChipMaxpar(status) {
      const colorsByStatus = {
        ['Não Sinconizada']: 'warning',
        ['Falha na Sincronização']: 'danger',
        ['Sincronizada']: 'success',
      };
      return colorsByStatus[status];
    },
    retornaJson(str) {
      return typeof str === 'string' ? JSON.parse(str) : '';
    },
    async execute() {
      this.$vs.loading();
      const payload = {
        policyId: this.policyId,
        action: this.action,
      };

      if (this.cancellationDate) {
        payload.cancellationDate = moment(
          this.cancellationDate,
          'DD/MM/YYYY',
        ).toDate();
        payload.endorsementNumber = parseInt(this.endorsementNumber);
      }

      if (this.changeEndorsementDate) {
        payload.changeEndorsementDate = moment(
          this.changeEndorsementDate,
          'DD/MM/YYYY',
        ).toDate();
        payload.endorsementNumber = parseInt(this.endorsementNumber);
        payload.numberOriginalPolicy = parseInt(this.numberOriginalPolicy);
      }

      try {
        await maxparApiService.execute(payload);
        notify.notifySuccess(this.$vs, 'Registro processado com sucesso.');
        this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao processar registro.');
      } finally {
        this.$vs.loading.close();
      }
    },
    getConfigDatePicker() {
      return {
        ...functions.getConfigDateTimePickerDay(),
        maxDate: new Date(),
      };
    },
    reloadData() {
      this.$emit('reload');
    },
  },
};
</script>
<style></style>
